// source: galaxycompletepb/apipb/domainpb/enumpb/deployment_host_environment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.galaxycomplete.domain.enums.DeploymentHostEnvironment', null, global);
goog.exportSymbol('proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.enums.DeploymentHostEnvironment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.displayName = 'proto.galaxycomplete.domain.enums.DeploymentHostEnvironment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.enums.DeploymentHostEnvironment;
  return proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment = {
  OTHER: 0,
  AWS: 1,
  AZURE: 2,
  GCP: 3,
  DO: 4,
  VMWARE: 5,
  HYPERV: 6,
  SOFTLAYER: 7,
  OPENSTACK: 8,
  VULTR: 9,
  UNKNOWN: 1000
};

/**
 * optional DeploymentHostEnvironment value = 1;
 * @return {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment}
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.prototype.getValue = function() {
  return /** @type {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.DeploymentHostEnvironment} value
 * @return {!proto.galaxycomplete.domain.enums.DeploymentHostEnvironment} returns this
 */
proto.galaxycomplete.domain.enums.DeploymentHostEnvironment.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto.galaxycomplete.domain.enums);
